import { defineMessages } from 'react-intl';

export default defineMessages({
    additionalInsuredInterestName:{
        id:'farm.additional-insured-interest.Name',
        defaultMessage:'Name'
    },
    additionalInsuredType:{
        id:'farm.additional-insured-interest.Type',
        defaultMessage:'Relationship To Primary Named Insured'
    },
    additionalInterestType:{
        id:'farm.additional-insured-interest.Interest Type',
        defaultMessage:'Interest Type'
    },
    additionalInsureds:{
        id:'farm.additional-insured-interest.Additional Insureds',
        defaultMessage:'Additional Insureds'
    },
    additionalInsured:{
        id:'farm.additional-insured-interest.Additional Insured',
        defaultMessage:'Additional Insured'
    },
    additionalNamedInsured:{
        id:'farm.additional-insured-interest.Additional Named Insured',
        defaultMessage:'Additional Named Insured'
    },
    anotherAdditionalNamedInsured:{
        id:'farm.additional-insured-interest.Add Another Additional Named Insured',
        defaultMessage:'Add Another Additional Named Insured?'
    },
    additionalInterests:{
        id:'farm.additional-insured-interest.Additional Interests',
        defaultMessage:'Additional Interest'
    },
    additionalInterest:{
        id:'farm.additional-insured-interest.Additional Interest',
        defaultMessage:'Additional Interest'
    },
    anotherAdditionalInterest:{
        id:'farm.additional-insured-interest.Add Another Additional Interest',
        defaultMessage:'Add Another Additional Interest?'
    },
    additionalInterestName:{
        id:'farm.additional-insured-interest.Name',
        defaultMessage:'Name' 
    },
    additionalInterestSave:{
        id:'farm.additional-insured-interest.Name',
        defaultMessage:'Name' 
    },
    additionalInterestCancel:{
        id:'farm.additional-insured-interest.Cancel',
        defaultMessage:'Cancel'
    } 
});
